import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import FormModal from '../Components/FormModal.js'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'

function Expenses () {
  const pageName = 'expenses'
  const pageTitle = 'Xərclər'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const expenses = await call.forLoggedUser.expense.getExpenses(params)
        if (expenses.success) {
          return expenses.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Tarix',
        property: 'date',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'date',
          name: 'date'
        },
        mutate: value => {
          return use.convertDatetimeToShortDate(value)
        }
      },
      {
        title: 'Filial',
        property: ['branchCode', 'branchName'],
        mutate: values => <span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: { width: '10%' }
      },
      {
        title: 'Xərcin növü',
        property: 'typeName',
        style: { width: '20%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'typeId',
          dataSource: async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'expenseType'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          }
        }
      },
      {
        title: 'Məbləğ',
        property: 'amount',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'number',
          name: 'amount'
        },
        mutate: value => {
          return (
            <p style={{ textAlign: 'right', paddingRight: '7px' }}>{value} ₼</p>
          )
        }
      },
      {
        title: 'Açıqlama',
        property: 'description',
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'description'
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type: 'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'expense'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'operations-list',
        operations: values => [
          {
            type: 'group',
            name: 'menu',
            title: 'Group',
            icon: '...',
            items: [
              {
                type: 'command',
                name: 'delete',
                title: 'Qeydi sil',
                parameters: JSON.stringify({id:values[0],entity:'expense'}),
                iconType: 'path',
                icon: '/Images/Icons/delete.png',
                disablingConditions: []
              }
            ]
          }
        ],
        style: { width: '5%', minWidth: '50px' }
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'expense',
      label: 'Xərclər',
      isStandAlone: true,
      isMain: true,
      id: '',
      actions: {
        get: id => call.forLoggedUser.expense.getExpenseById({ id: id }),
        add: call.forLoggedUser.expense.addExpense,
        edit: call.forLoggedUser.expense.updateExpense
      },
      formLists: {
        Branches: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          let data = source.data.map(d => {
            return { value: d.id, text: d.name }
          })
          return data
        },
        ExpenseTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'ExpenseType'
          })
          let data = source.data.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'expense'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Tarix',
          fieldName: 'date',
          validationRules: ['required'],
          defaultValue: new Date().toLocaleDateString('az-AZ'),
          type: 'date',
          col: { sm: 3 },
          mutate: value => {
            return value != null
              ? new Date(value).toLocaleDateString('az-AZ')
              : null
          }
        },
        {
          label: 'Filial',
          type: 'select',
          fieldName: 'branchId',
          validationRules: ['required'],
          col: { sm: 3 },
          data: 'Branches'
        },
        {
          label: 'Xərcin növü',
          type: 'select',
          fieldName: 'typeId',
          validationRules: ['required'],
          col: { sm: 3 },
          data: 'ExpenseTypes'
        },
        {
          label: 'Məbləğ',
          fieldName: 'amount',
          validationRules: ['required'],
          type: 'number',
          col: { sm: 3 }
        },
        {
          label: 'Açıqlama',
          fieldName: 'description',
          col: { sm: 6 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 0,
          col: { sm: 6 },
          data: 'Statuses'
        },
        {
          label: 'Əlavə qeydlər',
          fieldName: 'notes',
          type: 'textarea',
          col: { sm: 6 }
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>Xərclər</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Expenses
